import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
// import { getprofile } from '../../servicer/user';
import { userProfile } from '../../store/user/userThunk';
import { useDispatch, useSelector } from 'react-redux';

const Appprotector = ({ Componet }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const navigate = useNavigate();
  let dispatch = useDispatch();

  let { profile } = useSelector((state) => state.userservice);

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      const getuserprofile = async () => {
        dispatch(userProfile());
        //   console.log(data.data.data);
      };
      getuserprofile()
    }



  }, []);
  useEffect(() => {
    const path = window.location.pathname
    if (path == "/dashboards/profiles/fbprofile" || path == "/chat/fbchat" || path == "/chat/inbox") {
      if (profile?.Fblogin === false) {
        navigate('/dashboards');

        // swal({
        //   title: "Login required",
        //   text: "Please log in to continue.",
        //   icon: "warning",
        //   buttons: {
        //     cancel: {
        //       text: "login",
        //       value: null,
        //       visible: true,
        //       className: "btn-login",
        //       closeModal: true,
        //     }
        //   }
        // }).then(() => {
        //   // Redirect to login page
        //   navigate('/login');
        // });
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    }


    if (path == "/dashboards/profiles/igprofile" || path == '/chat/Igchat'  || path == '/chat/Igchat')
    // if(path=="/igProfile" )

    {
      if (profile?.iglogin === false) {
        navigate('/dashboards');

        // swal({
        //   title: "Login required",
        //   text: "Please log in to continue.",
        //   icon: "warning",
        //   buttons: {
        //     cancel: {
        //       text: "login",
        //       value: null,
        //       visible: true,
        //       className: "btn-login",
        //       closeModal: true,
        //     }
        //   }
        // }).then(() => {
        //   // Redirect to login page
        //   navigate('/login');
        // });
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    }
    if (path === "/chat/wpChat") {

      if (profile?.wpLogin === false) {
        navigate('/dashboards');

        // swal({
        //   title: "Login required",
        //   text: "Please log in to continue.",
        //   icon: "warning",
        //   buttons: {
        //     cancel: {
        //       text: "login",
        //       value: null,
        //       visible: true,
        //       className: "btn-login",
        //       closeModal: true,
        //     }
        //   }
        // }).then(() => {
        //   // Redirect to login page
        //   navigate('/login');
        // });
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    }
    if (path === "/dashboards/app/friendlist") {
      if (profile?.Fblogin === false && profile?.wpLogin === false && profile?.iglogin === false) {
        navigate('/dashboards');

      } else {
        setIsAuthenticated(true);
      }
    }
  }, [profile])
  return (
    <div>
      {isAuthenticated ? <Componet /> : null}
    </div>
  )
}

export default Appprotector
